// extracted by mini-css-extract-plugin
export default {"root":"app-core-components-form-components-SwitchField-Switch-module__root"};